import { RelativeTime, Typography } from '@compass/components'
import { DateTime } from 'luxon'

import useNormalizedDateTime from '../../../../../hooks/useNormalizedDateTime'
import { CellWrapper } from './CellAction'
import { columnHelper } from './columnHelper'
import { Unavailable } from './MissingData'

const ColumnWithValidTime = ({ time }: { time: number }) => {
  const dateObject = useNormalizedDateTime(time) as DateTime
  return (
    <CellWrapper>
      <RelativeTime date={dateObject}>
        <Typography className='tabular-nums text-nowrap'>{dateObject?.toFormat('MMM dd, HH:mm:ss')}</Typography>
      </RelativeTime>
    </CellWrapper>
  )
}

export const dateColumn = () =>
  columnHelper.accessor((row) => row.timestamp, {
    id: 'timestamp',
    header: 'Date',
    sortingFn: 'basic',
    cell: ({ row }) => {
      const time = row.original.timestamp

      if (!time) {
        return <Unavailable />
      }

      return <ColumnWithValidTime time={time} />
    },
  })
